import CascadiaCodeRegular from "./CascadiaCode-Regular.woff2";

import { type ExcalidrawFontFaceDescriptor } from "../Fonts";

export const CascadiaFontFaces: ExcalidrawFontFaceDescriptor[] = [
  {
    uri: CascadiaCodeRegular,
  },
];
